<template>
    <div class="video-content">
        <div class="pic-list">
            <div class="pic-item" v-for="item in defaultdata">
                <div class="pic-title">{{ item.value1 }}</div>
                <div class="del-val">
                    <div class="del-left">
                        <div class="val">{{ item.value3 }}</div>
                        <div class="name">{{ item.value2 }}</div>
                    </div>
                    <div class="del-right">
                        <div class="val">{{ item.value5 }}</div>
                        <div class="name">{{ item.value4 }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as methods from "./method.js";
export default {
    name: 'template.scope125',
    props: {
        vdata: {
            type: [Array, String],
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
        scopedata: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            defaultdata: [
                {
                    value1: "商户类型",
                    value2: '企业数',
                    value3: '66',
                    value4: '个体户',
                    value5: '1028'
                },{
                    value1: "许可证",
                    value2: '已完善',
                    value3: '66',
                    value4: '完善率',
                    value5: '99%'
                },{
                    value1: "从业人员",
                    value2: '从业证',
                    value3: '66',
                    value4: '健康证',
                    value5: '1028'
                },{
                    value1: "码牌记录",
                    value2: '已发放',
                    value3: '66',
                    value4: '已生效',
                    value5: '1028'
                },{
                    value1: "溯源追踪",
                    value2: '报备商户',
                    value3: '66',
                    value4: '个体户',
                    value5: '29954'
                },{
                    value1: "承诺书",
                    value2: '食品安全',
                    value3: '66',
                    value4: '完成率',
                    value5: '92.8%'
                },
            ],
            valueMap: [
                { name: "名称", key: "value1" },
                { name: "名称2", key: "value2" },
                { name: '数值2', key: 'value3' },
                { name: "名称3", key: "value2" },
                { name: '数值3', key: 'value3' },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
        }
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                this.defaultdata = n;
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
    },
    methods: {
        ...methods
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData(); //需要刷新的数据
    },
}
</script>

<style lang="scss" scoped>
.video-content {
    width: 435px;
    height: 240px;
    padding: 10px 0;
    position: relative;
    .pic-list {
        display: flex;
        flex-wrap: wrap;
        row-gap: 6px;
        column-gap: 6px;
    }
    .pic-item {
        width: 140px;
        height: 110px;
        background: url(@/assets/temimg15/pic-bg.png) no-repeat;
        background-size: 100% 100%;
        position: relative;
    }
    .pic-title {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 14px;
        padding: 16px 0 0 16px;
    }
    .del-val {
        margin: 24px 0 0 16px;
        display: flex;
        align-items: center;
        text-align: center;
        .val {
            font-family: Benmo Ziyu;
            font-weight: 400;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 14px;
        }
        .name {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 13px;
            color: #B5D6FF;
            line-height: 13px;
            margin-top: 9px;
        }
    }
    .del-right {
        margin-left: 24px;
    }
}
</style>